import React, { useEffect, useRef, useState } from 'react';

import './toolbox.scss';

import L, { LatLngBounds, LatLngExpression, LatLngLiteral } from 'leaflet';
import 'leaflet-arrowheads';

import styles from 'src/app/components/Toolbox/Toolbox.module.scss';

import SwitchLayerIcon from 'src/assets/SwitchLayerIcon.png';
import toolbarZoomIcon from 'src/assets/toolbarZoom.png';
import toolbarZoomActiveIcon from 'src/assets/toolbarZoomActive.png';
import toolbarZoomInIcon from 'src/assets/toolbarZoomIn.png';
import toolbarZoomOutIcon from 'src/assets/toolbarZoomOut.png';

import {
  MapDrawInputType,
  ToolboxActiveTabs,
  ToolboxDockedStatus,
  ToolboxLayout,
  ToolboxPropsType,
  TSitrepPanel,
} from 'src/app/components/Toolbox/toolbox.config';
import { reduxRootTypes } from 'src/types';
import { useDispatch, useSelector } from 'react-redux';
import { isDefined } from 'class-validator';
import { mapActions, unitsActions } from 'src/app/redux/actions';
import { SitrepSelectedType, TBarPosition } from 'src/types/mixed.type';
import { orderBy } from 'lodash';
import { getAgentName } from 'src/app/helpers/units.helper';
import DraggableModal from '../DraggableModal/DraggableModal';
import SitrepBar from '../BarComponent/SITREP/SitrepBar';
import ToolboxCollapsible from '../ToolboxCollapsible/ToolboxCollapsible';
import { layers } from 'src/configs/layers';
import rulerIcon from 'src/assets/ruler.png';
import rulerActiveIcon from 'src/assets/rulerActive.png';
import toolbarEditModeActiveIcon from 'src/assets/toolbarPencilActive.png';
import toolbarEditModeIcon from 'src/assets/toolbarPencil.png';
import DrawModuleWrapper from '../DrawModule/DrawModuleWrapper';
import { MapUnit, HlaMapUnit, UnitType } from 'src/types/unit.type';
import Menu from 'antd/es/menu';
import Dropdown from 'antd/es/dropdown/dropdown';

const Toolbox: React.FC<ToolboxPropsType> = ({
  mapViewState,
  map,
  mapVisualController,
  mapMarkerController,
  drawController,
  drawGroups,
  setDrawGroups,
}) => {
  const dispatch = useDispatch();

  const { userRoles } = useSelector((state: reduxRootTypes.RootStateType) => state.userState);
  const { sitrepSelectedUnits, misrepSelectedCommands, misrepSelectedUnits, commandQueueSelectedUnits } = useSelector(
    (state: reduxRootTypes.RootStateType) => state.unitsState,
  );
  const { activeTabs, mapZoom, availableLayers } = useSelector((state: reduxRootTypes.RootStateType) => state.mapState);

  // TODO Move to redux or move strategies here
  const [chooseLocationMarker] = useState<L.Marker>(new L.Marker({ lat: 0, lng: 0 }));

  const [dockedBars, setDockedBars] = useState<ToolboxDockedStatus>({
    ch: false,
    filter: false,
    intrep: false,
    misrep: false,
    theaterEditor: false,
    commandQueue: false,
  });

  const [chooseLocationActive, setChooseLocationActive] = useState(false);
  const [chooseLocationProps, setChooseLocationProps] = useState<L.LatLngLiteral | undefined>(undefined);

  // #region Section for handling draw inputs on command modal
  const [mapDrawInputs, setMapDrawInputs] = useState<Record<string, MapDrawInputType>>({});
  const [mapDrawInputsActives, setMapDrawInputsActives] = useState<Record<string, boolean>>({});

  const [unitsSelectedOnArea, setUnitsSelectedOnArea] = useState<number[] | undefined>(undefined);
  const [selectByAreaActive, setSelectByAreaActive] = useState(false);

  const { units, lastActivedBar, hlaMapUnits } = useSelector((state: reduxRootTypes.RootStateType) => state.unitsState);

  /**
   *
   * @param key input key (ex: MV_route)
   *
   *
   * @param defaultPoint Default start point for poly line routes. if true there is no need to give the polyline a default value
   *
   */

  // #endregion Section for handling draw inputs on command modal

  const [sitrepPanels, setSitrepPanels] = useState<TSitrepPanel[]>([]);

  const strepUnitTypeRef = useRef<UnitType>();

  useEffect(() => {
    let localPanels = [...sitrepPanels];

    localPanels = localPanels.filter((o) => sitrepSelectedUnits.some((a) => a.id === o.id));

    sitrepSelectedUnits.forEach((sitrepSelectedUnit) => {
      const panelExists = localPanels.some((o) => o.id === sitrepSelectedUnit.id);

      strepUnitTypeRef.current = sitrepSelectedUnit.unitType || 'hymotsc';

      if (!panelExists) {
        localPanels.push({
          id: sitrepSelectedUnit.id,
          isDocked: sitrepSelectedUnit.isDocked,
          timestamp: sitrepSelectedUnit.timestamp,
          collapsed: false,
          position: sitrepSelectedUnit.position,
        });
      }
    });

    setSitrepPanels(orderBy(localPanels, ['timestamp'], ['desc']));

    if (strepUnitTypeRef.current && strepUnitTypeRef.current == 'hymotsc') {
      units?.forEach((o) => {
        const elem = document.getElementsByClassName(`unit-icon-${o.id}`)[0];

        if (sitrepSelectedUnits.find((s) => s.id === o.id)) {
          // elem?.classList.add('sitrep-selected-unit-determiner');
          if (elem) elem.id = 'id-selected-unit-determiner';
        } else {
          // elem?.classList.remove('sitrep-selected-unit-determiner');
          if (elem) elem.removeAttribute('id');
        }
      });
    } else if (strepUnitTypeRef.current && strepUnitTypeRef.current == 'hla') {
      hlaMapUnits?.forEach((o) => {
        const elem = document.getElementsByClassName(`unit-icon-${o.id}`)[0];

        if (sitrepSelectedUnits.find((s) => s.id === o.id)) {
          // elem?.classList.add('sitrep-selected-unit-determiner');
          if (elem) elem.id = 'id-selected-unit-determiner';
        } else {
          // elem?.classList.remove('sitrep-selected-unit-determiner');
          if (elem) elem.removeAttribute('id');
        }
      });
    }
  }, [sitrepSelectedUnits, mapZoom, units, hlaMapUnits]);

  const toggleSitrepCollapsed = (id?: number) => {
    if (id) {
      const localPanels = [...sitrepPanels];

      const panelToUpdate = localPanels.find((o) => o.id === id);

      if (panelToUpdate) {
        panelToUpdate.collapsed = !panelToUpdate.collapsed;

        setSitrepPanels(orderBy(localPanels, ['timestamp'], ['desc']));
      }
    }
  };

  const findLastActiveBarPosition = (id: number) => {
    if (lastActivedBar) {
      switch (lastActivedBar?.type) {
        case 'sitrep':
          const lastSitrepBar = sitrepSelectedUnits.find((o) => o.id === lastActivedBar.id);
          if (lastSitrepBar && lastSitrepBar.position) {
            dispatch(
              unitsActions.changeSitrepPosition(id, {
                x: lastSitrepBar.position.x + 30,
                y: lastSitrepBar.position.y + 30,
              }),
            );
            return {
              x: lastSitrepBar.position.x + 30,
              y: lastSitrepBar.position.y + 30,
            };
          }
          return undefined;

        default:
          return undefined;
      }
    }
  };

  const onChangeSitrepDocked = (id: number, bool?: boolean) => {
    const item = sitrepPanels.find((o) => o.id === id);
    const index = sitrepPanels.findIndex((o) => o.id === id);
    if (item && index >= 0) {
      if (item.isDocked) {
        setSitrepPanels([
          ...sitrepPanels.slice(0, index),
          {
            ...item,
            isDocked: bool !== undefined ? bool : !item.isDocked,
            position: findLastActiveBarPosition(id) || item.position,
          },
          ...sitrepPanels.slice(index + 1),
        ]);
        dispatch(unitsActions.setLastActiveBar(id, 'sitrep'));
      } else {
        setSitrepPanels([
          ...sitrepPanels.slice(0, index),
          {
            ...item,
            isDocked: bool !== undefined ? bool : !item.isDocked,
          },
          ...sitrepPanels.slice(index + 1),
        ]);
      }
    }
    // dispatch(unitsActions.toggleSitrepDock(id));
  };

  const toggleTabActive = (key: keyof ToolboxActiveTabs) => {
    // Ruler and Magnifier cannot be active at the same time
    if (key === 'ruler') {
      dispatch(mapActions.toggleActiveTab({ key }));
      dispatch(mapActions.setActiveTab({ key: 'magnifier', bool: false }));
    } else if (key === 'magnifier') {
      dispatch(mapActions.toggleActiveTab({ key }));
      dispatch(mapActions.setActiveTab({ key: 'ruler', bool: false }));
    } else if (key === 'sitrep') {
      if (sitrepSelectedUnits.length > 0) {
        dispatch(mapActions.toggleActiveTab({ key }));
      } else {
        dispatch(mapActions.setActiveTab({ key, bool: false }));
      }
    } else {
      dispatch(mapActions.toggleActiveTab({ key }));
    }
  };

  const setTabActive = (key: keyof ToolboxActiveTabs, bool: boolean) => {
    dispatch(mapActions.setActiveTab({ key, bool }));
  };

  const toggleDocked = (key: keyof ToolboxDockedStatus) => {
    setDockedBars({
      ...dockedBars,
      [key]: !dockedBars[key],
    });
  };

  // TODO
  /**
   * When activating magnifier when ruler is already on, because of order of the useEffects.
   * Dragging get enable first when magnifier is true and get disabled because ruler gets false
   */
  useEffect(() => {
    if (activeTabs.magnifier) {
      setTimeout(() => {
        mapVisualController?.onZoomToggle(activeTabs.magnifier);
      }, 1);
    } else {
      mapVisualController?.onZoomToggle(activeTabs.magnifier);
    }
  }, [activeTabs.magnifier]);

  useEffect(() => {
    if (activeTabs.ruler) {
      setTimeout(() => {
        mapVisualController?.onRulerToggle(activeTabs.ruler);
      }, 1);
    } else {
      mapVisualController?.onRulerToggle(activeTabs.ruler);
    }
  }, [activeTabs.ruler]);

  const onChooseLocation = (e: L.LeafletMouseEvent) => {
    setChooseLocationProps({ lat: Number(e.latlng.lat.toFixed(6)), lng: Number(e.latlng.lng.toFixed(6)) });
  };

  useEffect(() => {
    if (chooseLocationActive !== undefined && chooseLocationProps && map) {
      chooseLocationMarker.setLatLng(chooseLocationProps);
      if (chooseLocationActive) {
        chooseLocationMarker.addTo(map);
      } else {
        setChooseLocationProps(undefined);
        chooseLocationMarker.remove();
      }
    }
  }, [map, chooseLocationProps, chooseLocationActive]);

  const toolboxLayout: ToolboxLayout = {
    topSection: [
      {
        key: '3',
        activeHandler: activeTabs.sitrep,
        id: 'sitrep',
        onClick: () => {
          toggleTabActive('sitrep');
        },
        labelId: 'toolbarSitrep',
        label: 'SITREP',
        order: 4,
      },
    ],
    middleSection: [],
    bottomSection: [
      {
        key: '16', // EditMode
        id: 'editMode',
        onClick: () => {
          toggleTabActive('editMode');
        },
        order: 1,
        imgId: 'toolbarIcon11',
        imgAlt: 'Edit Mode',
        imgSrc: activeTabs.editMode ? toolbarEditModeActiveIcon : toolbarEditModeIcon,
      },
      {
        key: '11',
        id: 'rule',
        onClick: () => {
          toggleTabActive('ruler');
        },
        order: 1,
        imgId: 'toolbarIcon6',
        imgAlt: 'toolbar11',
        imgSrc: activeTabs.ruler ? rulerActiveIcon : rulerIcon,
      },
      {
        key: '13',
        id: 'magnifier',
        onClick: () => {
          toggleTabActive('magnifier');
        },
        order: 3,
        imgId: 'toolbarIcon8',
        imgAlt: 'toolbar8',
        imgSrc: activeTabs.magnifier ? toolbarZoomActiveIcon : toolbarZoomIcon,
      },
      {
        key: '14',
        id: 'zoomOut',
        onClick: () => {
          mapVisualController?.zoomOut();
        },
        order: 4,
        imgId: 'toolbar9',
        imgAlt: 'toolbar9',
        imgSrc: toolbarZoomOutIcon,
      },
      {
        key: '15',
        id: 'zoomIn',
        onClick: () => {
          mapVisualController?.zoomIn();
        },
        order: 5,
        imgId: 'toolbarIcon10',
        imgAlt: 'toolbar10',
        imgSrc: toolbarZoomInIcon,
      },
    ],
  };
  useEffect(() => {
    if (sitrepSelectedUnits.length === 0) {
      setTabActive('sitrep', false);
    }
  }, [sitrepSelectedUnits]);

  const renderSITREP = (sitrepBarData?: SitrepSelectedType, isDocked?: boolean, collapsed?: boolean) => {
    let unitData: MapUnit | HlaMapUnit | undefined;

    if (sitrepBarData?.unitType === 'hla') {
      unitData = hlaMapUnits.find((o) => o.id === sitrepBarData?.id);
    } else {
      unitData = units.find((o) => o.id === sitrepBarData?.id);
    }

    if (unitData && sitrepBarData) {
      const handleCloseToolBoxSitrep = () => {
        dispatch(unitsActions.sitrepDeselectUnit(sitrepBarData.id || -1));
      };
      return (
        <ToolboxCollapsible
          key={`sitrep_${sitrepBarData.id}`}
          headerText={`SITREP (${getAgentName(unitData)})`}
          onClickPin={() => onChangeSitrepDocked(sitrepBarData.id || -1)}
          pinStatus={!isDocked}
          onClickClose={handleCloseToolBoxSitrep}
          forceDisplayClose={isDocked}
          id={`sitrep_${sitrepBarData.id}`}
          onCollapseChange={() => {
            toggleSitrepCollapsed(sitrepBarData.id);
            dispatch(unitsActions.toggleSitrepUnitUnvisible(sitrepBarData.id || -1));
          }}
          collapsed={collapsed}
        >
          <SitrepBar key={`sitrep_${sitrepBarData.id}`} selectedUnitData={sitrepBarData} />
        </ToolboxCollapsible>
      );
    }
    return <></>;
  };

  const layerMenuOnClick = (id: string) => {
    dispatch(mapActions.setActiveLayer(id));
  };

  const toggleLayerMenu = (
    <Menu onClick={(e) => layerMenuOnClick(e.key)} className="myMenu">
      {availableLayers
        .filter((o) => o.id && o.isBaseLayer && o.isActive)
        .map((layer) => (
          <Menu.Item key={layer.id}>{layer.label}</Menu.Item>
        ))}
    </Menu>
  );

  const changeBarPosition = (type: 'sitrep' | 'misrep' | 'cq', id: number, position: TBarPosition) => {
    switch (type) {
      case 'sitrep':
        dispatch(
          unitsActions.changeSitrepPosition(id, {
            x: position.x,
            y: position.y,
          }),
        );
        dispatch(unitsActions.setLastActiveBar(id, 'sitrep'));
        break;

      default:
        break;
    }
  };

  return (
    <>
      <DrawModuleWrapper drawController={drawController} drawGroups={drawGroups} setDrawGroups={setDrawGroups} />

      {activeTabs.sitrep &&
        sitrepPanels.length > 0 &&
        sitrepPanels
          .filter((o) => !o.isDocked)
          .map((panel) => {
            return (
              <DraggableModal
                key={panel.id}
                headerText="SITREP"
                className={styles.drag}
                contentClassName={styles.dragContent}
                position={panel.position}
                onClickClose={() => {
                  setTabActive('sitrep', false);
                }}
                isHeaderOn={false}
                onStop={(pos: TBarPosition) => {
                  changeBarPosition('sitrep', panel.id, pos);
                }}
                id={panel.id.toString()}
              >
                {renderSITREP(
                  sitrepSelectedUnits.find((o) => o.id === panel.id),
                  panel.isDocked,
                  false,
                )}
              </DraggableModal>
            );
          })}

      <div className={`${styles.barContainer} toolbox-bar-container`}>
        {activeTabs.sitrep &&
          sitrepPanels
            .filter((o) => o.isDocked)
            .map((panel) =>
              renderSITREP(
                sitrepSelectedUnits.find((o) => o.id === panel.id),
                panel.isDocked,
                panel.collapsed,
              ),
            )}
      </div>

      <div className={styles.Toolbar} key="toolbar" id="toolbar">
        {userRoles && (
          <>
            <div className={styles.TopSection} key="topSection">
              {toolboxLayout.topSection
                .sort((a1, a2) => a1.order - a2.order)
                .map((element) => (
                  <div
                    className={
                      isDefined(element.activeHandler)
                        ? !element.activeHandler
                          ? 'map-toolbar-button-div'
                          : 'map-toolbar-button-div map-toolbar-button-div-active'
                        : 'map-toolbar-button-div secondary-bg'
                    }
                    key={element.key}
                    onClick={element.onClick}
                    style={sitrepSelectedUnits.length === 0 && element.id === 'sitrep' ? { cursor: 'default' } : {}}
                  >
                    {element.imgId ? (
                      <img key={element.key} id={element.imgId} src={element.imgSrc} alt={element.imgAlt} />
                    ) : (
                      <div className="parameterContainer" id={element.labelId}>
                        <p className="parameterContainerValue">{element.label}</p>
                      </div>
                    )}
                  </div>
                ))}
            </div>

            <div className={styles.BottomSection} key="bottomSection">
              {toolboxLayout.bottomSection
                .sort((a1, a2) => a1.order - a2.order)
                .map((element) => (
                  <div
                    className={
                      isDefined(element.activeHandler)
                        ? !element.activeHandler
                          ? 'map-toolbar-button-div'
                          : 'map-toolbar-button-div map-toolbar-button-div-active'
                        : 'map-toolbar-button-div secondary-bg'
                    }
                    key={element.key}
                    onClick={element.onClick}
                  >
                    {element.imgId ? (
                      <img key={element.key} id={element.imgId} src={element.imgSrc} alt={element.imgAlt} />
                    ) : (
                      <div className="parameterContainer" id={element.labelId}>
                        <p className="parameterContainerValue">{element.label}</p>
                      </div>
                    )}
                  </div>
                ))}
              <div className="map-toolbar-button-div secondary-bg" key="-1" onClick={() => {}}>
                <Dropdown
                  overlay={toggleLayerMenu}
                  trigger={['click']}
                  placement="bottomLeft"
                  className="layerSelectionDropdown"
                >
                  <img key="-1" id="toolbarIcon9" src={SwitchLayerIcon} alt="toolbar9" />
                </Dropdown>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default Toolbox;
